import { Dumbbell, Lightbulb, Moon, Sparkles, Sun, Trophy } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import logo from "../../assets/logo.png";
import * as motion from "motion/react-client";

const WelcomePage = () => {
    const navigate = useNavigate()
    const [start, setStart] = useState(false);
    const clickHandler = () => {
        setStart(true);
        setTimeout(() => {
            navigate("/home")
        }, 1500)
    }
    return (<div className={"flex flex-col text-2xl items-center justify-center"}>
        <motion.div className={"flex flex-col items-center justify-center gap-8"}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: start ? 0 : 1 }}
                    transition={{ duration: 1.5, delay: 0.15, ease: start ? "anticipate" : undefined }}>
            <div className="flex items-center justify-center gap-4" >
                <motion.div initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.2 }}>
                    <Lightbulb />
                </motion.div>
                <motion.div initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.4 }}>
                    <Dumbbell />
                </motion.div>
                <motion.div initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.6 }}>
                    <Trophy />
                </motion.div>
            </div>
            <div>
                <motion.div initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 0.8 }}>
                    Master <code>math</code>
                </motion.div>
            </div>
            <div>
                <motion.div
                    initial={{ y: -100, rotate: -90, opacity: 0 }}
                    animate={{ y: 0, rotate: start ? 1080 : 180, opacity: 1}}
                    transition={{
                        y: {
                            type: "spring",
                            stiffness: 80,
                            damping: 12
                        },
                        rotate: {
                            duration: 4,
                            ease: "linear",
                            repeat: Infinity,
                            repeatType: "loop"
                        },
                        opacity: { duration: 1 },
                    }}
                    className="flex items-center justify-center w-50 rounded-full cursor-pointer"
                    onClick={clickHandler}
                >
                    <motion.img
                        src={logo}
                        alt="Sun Icon"
                        className="hover:scale-110 transition-transform duration-300"
                        width={225}
                    />
                </motion.div>
            </div>
            <div>
                <motion.div initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 1.2 }}
                >
                    on most days.
                </motion.div>
            </div>
            <div className="flex gap-4">
                <motion.div initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 1.4 }}>
                    <Sun />
                </motion.div>
                <motion.div initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 1.6 }}>
                    <Sparkles />
                </motion.div>
                <motion.div initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.8, delay: 1.8 }}>
                    <Moon />
                </motion.div>
            </div>
        </motion.div>
        {/*<div>*/}
        {/*    <motion.div*/}
        {/*        initial={{ opacity: 0, y: -20 }}*/}
        {/*        animate={{ opacity: 1, y: 0 }}*/}
        {/*        transition={{ duration: 0.4, delay: 3 }}*/}
        {/*        className={{ fontSize: "14px",*/}
        {/*            color: "gray" }}>*/}
        {/*        © 2025 OnMostDays. All rights reserved.*/}
        {/*    </motion.div>*/}
        {/*</div>*/}
    </div>)
}

export default WelcomePage;